module.exports = __webpack_public_path__ + "img/shield-check.8f300239.svg";